
import React, { useEffect, useState } from 'react'
import '../../../../Styles/Ht.css';
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls';
import { CommonAxiosGet, } from '../../../CommonUtilities/CommonAxios/CommonAxios';
import { CommonPageHeading } from '../../../CommonUtilities/CommonHeading/CommonPageHeading';
import { CommonReactTable } from '../../../CommonUtilities/CommonTable/CommonReactTable';
export default function ObjectionReport() {

    const [showExamDate, setExamDate] = useState([]);
    function renderExams() {
        let Url = config.url.CONTEXT_READ_URL + "tet-candidate-objections"
        CommonAxiosGet(Url).then((res) => {
            if (res?.data?.status === true) {
                setExamDate(res?.data?.data);
            } else {
                setExamDate([])
            }
        })
    }
    useEffect(() => { renderExams() }, []);
    const objColumns = [
        { Header: 'S.No.', accessor: (row, index) => index + 1 },
        { Header: () => 'Paper', accessor: 'post_name' },
        { Header: () => 'Question Id', accessor: 'question_id' },
        { Header: () => 'Objection Type', accessor: 'obj_question' },
        {
            Header: () => 'Candidate Answer', accessor: 'candidate_ans', Cell: ({ row }) => (
                <span>
                    {row?.original?.candidate_ans ? row?.original?.candidate_ans : '-'}
                </span>
            )
        },
        { Header: () => 'Explanation/Any Reference /Remarks', accessor: 'remarks' },
    ]
    return (
        <div className="p-0 mt-4" >
            <CommonPageHeading heading='AP TET-2025 Objection(s) Entry Report' />

            {showExamDate?.length > 0 ? <CommonReactTable
                data={showExamDate}
                columns={objColumns}
                serachAlign='left'
                pagination='false'
                search='true'
                showFooter='false'
                filename='Report'
                paginationCount='All'
            /> : <div className='alert alert-warning'>NO DATA FOUND</div>}


        </div>)
}
